module.exports = __webpack_public_path__ + "img/e8b352b348837b1a0b0e0271172e4f03.svg";